<template>
  <div v-show="!loading">
    <q-layout view="hHh LpR fFf">
      <q-header elevated class="bg-accent text-white">
        <q-toolbar>
          <q-toolbar-title>
            <router-link
              v-if="accesoAdmin"
              tag="span"
              id="title"
              to="Presupuestos"
              >Tecnologías sin zanja</router-link
            >
            <span v-else>Tecnologías sin zanja</span>
          </q-toolbar-title>
          <div class="logo">
            <a href="https://www.veolia.es/hubgrade" target="_blank">
              <img src="@/assets/img/panel/hubgrade-blanco.svg" />
            </a>
          </div>
          <pre></pre>
          <q-item style="text-align: center"></q-item>
          {{ $store.getters["TSZ/userMail"] }}
          <pre></pre>
          <q-btn
            v-if="accesoAdmin"
            flat
            round
            dense
            icon="account_circle"
            @click="abrirMisDatos"
          />
          <q-btn v-else flat round dense icon="account_circle" />
        </q-toolbar>
      </q-header>
      <q-page-container v-if="canSeeApp">
        <router-view />
      </q-page-container>
      <q-page-container v-else>
        <div class="q-pa-md row items-start q-gutter-md">
          <q-card class="my-card">
            <q-card-section
              >No dispone de acceso a la Aplicación.</q-card-section
            >
          </q-card>
        </div>
      </q-page-container>
      <q-footer elevated class="accent dark">
        <q-toolbar>
          <q-toolbar-title></q-toolbar-title>
        </q-toolbar>
      </q-footer>
    </q-layout>

    <q-dialog
      v-model="mostrar_info"
      seamless
      v-show="mostrar_info"
      :position="position"
      full-height
    >
      <q-card style="width: 450px; padding-top; top:30px; bottom:30px">
        <div class="flex-container">
          <div class="flex-item_50">
            <q-card-section>
              <div class="card_titulo_text">Mis Datos</div>
            </q-card-section>
          </div>
          <div class="flex-item_50">
            <q-card-section align="right">
              <q-btn flat icon="close" v-close-popup />
            </q-card-section>
          </div>
        </div>

        <q-card-section align="right">
          <div class="nombre">{{ nombre_completo }}</div>
          <div class="card_titulo_text">{{ email }}</div>
          <div class="nombre">{{ empresa }}</div>
          <div v-show="!usuario_externo" class="card_titulo_text">
            {{ cargo }}
          </div>
          <div class="card_titulo_text">{{ telefono }}</div>
        </q-card-section>
        <br />
        <br />
        <br />
        <br />
        <br />
        <q-card-actions v-show="usuario_externo" align="left">
          <q-btn
to=""
class="ma-2"
text-color="white"
color="primary"
            >editar datos</q-btn
          >
        </q-card-actions>
        <q-card-actions align="left" style="left:30px; padding-left; ">
          <q-btn
@click="irLogout"
class="ma-2"
text-color="white"
color="primary"
            >cerrar sesión</q-btn
          >
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import '@/components/Presupuestos/assets/css/css_app_vue.css';

import {
  QLayout,
  QHeader,
  QFooter,
  QPageContainer,
  QToolbar,
  QToolbarTitle,
  QDialog
} from 'quasar';
export default {
  components: {
    QLayout,
    QHeader,
    QFooter,
    QPageContainer,
    QToolbar,
    QToolbarTitle,
    QDialog
  },
  created () {
    this.$store.commit('TSZ/mostrarMisDatos', false);

    if (process.env.VUE_APP_ACCESO_ADMIN == 1) {
      this.$store.dispatch('TSZ/loadUserRoles');
    }
  },
  data () {
    return {
      loading: false,
      mostrar_info: false,

      open: false,
      position: 'right',
      usuario_externo: false,
      nombre_completo: '',
      email: '',
      empresa: '',
      cargo: '',
      telefono: ''
    };
  },
  computed: {
    canSeeApp () {
      if (process.env.VUE_APP_ACCESO_ADMIN == 1) {
        if (this.rolAplicacion == -1) {
          this.loading = true;
        } else {
          this.loading = false;
        }

        if (this.rolAplicacion === 99) {
          return false;
        }
        return true;
      } else {
        this.loading = false;
        return true;
      }
    },
    rolAplicacion () {
      return this.$store.getters['TSZ/rolAplicacion'];
    },
    accesoAdmin () {
      let isadmin = process.env.VUE_APP_ACCESO_ADMIN;

      if (isadmin == 1) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    irLogout () {
      this.$store.dispatch('TSZ/logout');
      this.$router.go();
    },

    abrirMisDatos () {
      this.mostrar_info = true;
      this.cargar_mis_datos();
    },

    cargar_mis_datos () {
      this.$store
        .dispatch('TSZ/getDataUser')
        .then((resp) => {
          this.nombre_completo =
            resp.data.profile.apellidos + ',  ' + resp.data.profile.nombre;
          this.email = this.$store.getters['TSZ/userMail'];
          this.empresa = resp.data.profile.empresa;
          this.telefono = resp.data.profile.telefono;
          if (resp.data.adminSuit == true) {
            this.usuario_externo = true;
          }
        })
        .catch((err) => {
          this.mostrar_mensajes(err.response.data, 'red', 0);
        });
    },

    mostrar_mensajes (mensaje, color = 'red', timeout = 5000) {
      this.showError(mensaje, color, timeout);
    },

    showError (text, color, timeout) {
      this.$q.notify({
        message: text,
        color: color,
        icon: 'warning',
        timeout: timeout,
        position: 'top-right',
        progress: true,
        actions: [{ icon: 'close', color: 'white' }]
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  img {
    margin-top: 10px;
    max-width: 135px;
    padding: 0px 0 0 0;
    height: 40px;
    align-items: center;
  }
  i {
    padding: 18px 2% 0 5%;
  }
}
#title {
  cursor: pointer;
}
.card_titulo_text {
  color: black;
  font-size: 17px;
}

.nombre {
  color: rgb(65, 64, 64);
  font-size: 16px;
  text-align: right;
  font-weight: bold;
}
</style>
